import React, { useState } from 'react';
import './employerform3.css';
import { FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Form, Button, Row, Col, Image, Card } from 'react-bootstrap';
import bar03 from '../../../images/bar03.svg';

function Employerform3() {
  
  const navigate = useNavigate();

  return (
    <Container fluid className='p-0 m-0'>
      <div className='d-flex align-items-center text-center  gap-4 py-5 px-3'>
      <FaArrowLeft className='arrow' onClick={() => navigate("/employerform2")} />
      <h3 className='mt-4'>Back</h3>
      </div>
      <Container fluid className='p-3 p-sm-5' style={{ background: 'rgba(255, 161, 94, 0.55)',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'}}>
        <div className='d-block align-items-center justify-content-center text-center py-3'>
        <Image fluid src={bar03} alt='bar' />
        <h2 className='form-head mt-4'>Confirm Sign up</h2>
        </div>
        <Card className='flex-column mt-4 p-2 gap-3 border-0 complete-details' style={{ background: 'rgba(204, 204, 221, 0.55)',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.5)', width:'auto'}}>
            <div className='d-block d-sm-flex '>
            <p className=''>Company Name:&nbsp;</p>
            <h6 className='mt-2 mt-sm-0'>LS Design Boutique</h6>
            
            </div>
            <div className='d-block d-sm-flex '>
            <p>Telephone Number: &nbsp; </p>
            <h6 className='mt-2 mt-sm-0'>+234 **** ****</h6>
        
            </div>
            <div className='d-block d-sm-flex '>
            <p>Country: &nbsp; </p>
            <h6 className='mt-2 mt-sm-0'>Libya</h6>
            
            </div>
            <div className='d-block d-sm-flex '>
            <p>Email Address: &nbsp; </p>
            <h6 className='mt-2 mt-sm-0'>WE_design@gmail.com</h6>
            </div>
            <div className='d-block d-sm-flex '>
            <p>LinkedIn / Instagram: &nbsp;</p>
            <h6 className='mt-2 mt-sm-0'>LS_Boutique22</h6>
            
            </div>
            <div className='d-block d-sm-flex '>
            <p>Company Website: &nbsp;</p>
            <h6 className='mt-2 mt-sm-0'>ls_boutique.com</h6>
            </div>
            <div className='d-block d-sm-flex '>
            <p>Password: &nbsp; </p>
              <h6 className='mt-2 mt-sm-0'>***********</h6> 
           
            </div>
         
            <div className='d-block d-sm-flex '>
            <p>Confirm Password: &nbsp;</p>
              <h6 className='mt-2 mt-sm-0'>***********</h6>
            </div>
          
        </Card>
        <div className='mt-4 d-flex text-center justify-content-center align-items-center mx-3'> 
        <Link to="/employerdashboard" className='next-button'>Complete
          </Link>
        </div>
       

      </Container>
   
    </Container>
    
  );
}
export default Employerform3;